import styled from 'styled-components'
import { THEME } from '../constant'

export const ThemeProviderWrapper = styled.div``
